<template>
    <div class="withdraw" >
        <div v-if="userinfo.user_type==1">
            <div class="top-box">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="tab-list d_flex a_c ">
                    <h2>财务管理</h2>
                    <div class="item" @click="setWithdraw"><i class="icon el-icon-circle-plus" type="primary"></i>金额设置</div>
                </div>
            </div>
            <div class="page-content">
                <div class="table-box" >
                    <div class="total-box d_flex" style="margin-bottom: 20px;color: #f00;">
                        <div class="item" style="margin-right: 40px">总笔数：<span style="font-size: 20px;font-weight: bold">{{totalNum}}</span>条</div>
                        <div class="item" style="margin-right: 40px">总金额：<span style="font-size: 20px;color: #f00;font-weight: bold">{{total_money}}</span>元</div>
                        <div class="item">未审数：<span style="font-size: 20px;color: #f00;font-weight: bold">{{uncheck_total||0}}</span>条</div>
                    </div>
                    <el-form ref="form" v-model="form" :inline="true" class="demo-form-inline">
                        <el-form-item label="手机号">
                            <el-input v-model="form.mobile" placeholder="请输用户手机号" clearable @clear="bankList()"></el-input>
                        </el-form-item>
                        <el-form-item label="时间">
                            <el-date-picker
                                    v-model="form.date"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    @clear="bankList()"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="状态" >
                            <el-select v-model="form.status" clearable @clear="bankList()" placeholder="请选择状态" style="width: 150px;">
                                <el-option label="已拒绝" value="2"></el-option>
                                <el-option label="通过" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                            :data="tableData"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="bank_man"
                                label="用户名称"
                                align="center"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="mobile"
                                align="center"
                                label="手机号">
                        </el-table-column>
                        <el-table-column
                                prop="bank_name"
                                label="账号类型"
                                align="center"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="bank_number"
                                align="center"
                                label="账号">
                        </el-table-column>
                        <el-table-column
                                prop="money"
                                align="center"
                                label="提现金额">
                        </el-table-column>
                        <el-table-column
                                prop="create_time"
                                align="center"
                                label="申请时间">
                        </el-table-column>
                        <el-table-column
                                prop="check_time"
                                align="center"
                                label="审核时间">
                        </el-table-column>
                        <el-table-column
                                prop="check_remark"
                                align="center"
                                label="	审核备注">
                        </el-table-column>
                        <el-table-column
                                prop="check_username"
                                align="center"
                                label="	审核人">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                align="center"
                                label="状态">
                            <template slot-scope="scope">
                                <span>{{scope.row.status==1?'通过':(scope.row.status==2?'拒绝':'')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  label="操作" align="center" width="180px" >
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status<1" type="text" size="small" @click="passRow(scope.row)">通过</el-button>
                                <el-button v-if="scope.row.status<1" type="text" size="small" @click="refuseRow(scope.row)">拒绝</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="pages"
                            :current-page="page"
 :page-size="20"
                            @current-change="handleCurrentChange"
                            style="margin-top: 20px; text-align: right;"
                    >
                    </el-pagination>
                </div>
            </div>
            <el-dialog
                    title="拒绝原因"
                    :visible.sync="refusePop"
                    width="500px"
                    style="text-align: left"
            >
                <div class="pop-box">
                    <el-input type="textarea" v-model="remark" maxlength="100" placeholder="请输入拒绝原因" style="margin-bottom:20px ;"></el-input>
                    <div class="btn-box">
                        <el-button type="primary" @click="subRefuse">确认</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
        <div v-else>
            <div class="top-box">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="tab-list d_flex a_c ">
                    <h2>财务管理</h2>
                    <div class="item" @click="toCount"><i class="icon el-icon-circle-plus" type="primary"></i>提现账号管理</div>
                </div>
            </div>
            <div class="page-content p20">
                <div class="box bg_fff p20" style="text-align: left">
                    <h2 style="margin-bottom: 20px;">提现管理</h2>
                    <div class="count-info d_flex a_c j_b" style="width: 100%;height: 200px;padding: 0 50px;background-color:#4C9FF9;margin-bottom: 20px; color: #ffffff;font-size: 24px;">
                        <div class="left d_flex">
                            <div class="tit"><i class="icon el-icon-s-finance"></i><span style="font-size: 16px;">可提现金额（元）</span></div>
                            <div class="number-box" style="margin-right: 30px;">
                                <div class="number" style="font-weight: bold">{{userinfo.balance}}</div>
                            </div>
                            <el-button @click="toApply"  type="danger" plain>申请提现</el-button>
                        </div>
                       <div class="right ">
                          <span  style="font-size: 16px;"> 累计提现（元）：</span><span style="font-weight: bold">{{userinfo.total_amount}}</span><span></span>
                       </div>
                    </div>
                    <h2 style="margin-bottom: 20px;">提现记录</h2>
                    <div class="table">
                        <el-table
                                :data="recodeData"
                                border
                                style="width: 100%">
                            <el-table-column
                                    prop="create_time"
                                    label="日期"
                                    align="center"
                                    width="180">
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    label="交易类型"
                                    align="center"
                                    width="180">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.type==1">收入</span>
                                    <span v-if="scope.row.type==2">提现</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="money"
                                    align="center"
                                    label="交易金额">
                            </el-table-column>
                            <el-table-column
                                    prop="balance"
                                    align="center"
                                    label="结余金额">
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="cpages"
                                :current-page="cpage"
                                @current-change="recodeChange"
                                style="margin-top: 20px; text-align: right;"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {bankList,updateStatus} from '../../api/withdraw'
    import {seeFinancial} from '../../api/role'
    export default {
        name: "withdraw",
        data(){
            return{
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                refusePop:false,
                form:{
                    status:'',
                    mobile:'',
                    stime:'',
                    etime:'',
                    date:''
                },
                value1: '',
                value2: '',
                city_name:'',
                tableData: [],
                pages:1,
                page:1,
                remark:'',
                refuseData:null,
                userinfo:'',
                recodeData:[],
                cpage:1,
                cpages:1,
                totalNum:0,
                total_money:0,
                uncheck_total:0,
            }
        },
        mounted(){
            this.bankList();
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            console.log(this.userinfo)
            if(this.userinfo.role_id!=1){
                this.getInfo();
            }
        },
        methods:{
            bankList(){
                if(this.form.date){
                    this.form.stime=this.form.date[0];
                    this.form.etime=this.form.date[1];
                }
                bankList({
                    p:this.page,
                    ...this.form
                }).then(res=>{
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.pages=res.data.total_num;
                        this.totalNum=res.data.total_num;
                        this.total_money=res.data.total_money;
                        this.uncheck_total=res.data.uncheck_total;
                    }
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.bankList();
            },
            recodeChange(val){
                this.cpage = val;
                this.getInfo();
            },
            onSubmit(){
                this.page=1;
                this.bankList();
            },
            toRecord(){
                this.$router.push({path:'./record'})
            },
            toSetting(){
                this.$router.push({path:'./setting'})
            },
            passRow(row){
                updateStatus({
                    bank_id:row.bank_id,
                    status:1
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.bankList();
                    }
                })
            },
            refuseRow(row){
                this.refusePop=true;
                this.refuseData=row;
            },
            subRefuse(){
                if(!this.remark){
                    this.$message.error('请输入拒绝原因')
                    return;
                }
                updateStatus({
                    bank_id:this.refuseData.bank_id,
                    status:2,
                    remark:this.remark
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.refusePop=false;
                        this.refuseData='';
                        this.bankList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            toCount(){
                this.$router.push({path:'/withdraw/count'})
            },
            toApply(){
                if(this.userinfo.balance<10){
                    this.$alert('您的可提现金额不足，暂不能申请提现', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {

                        }
                    });
                    return;
                }
                this.$router.push({path:'/withdraw/apply'})
            },
            setWithdraw(){
                this.$router.push({path:'/withdraw/setdk'})
            },
            getInfo(){
                seeFinancial({
                    uid:this.userinfo.admin_id,
                    utype:2,
                    p:this.cpage,
                }).then(res=>{
                    if(res.code==1){
                        this.recodeData=res.data.list;
                        this.cpages=res.data.total_page;
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-content{
    padding: 20px;
    .table-box{
        background-color: #fff;
        padding: 20px;
        text-align: left;
    }
}
</style>

<style>
    .el-date-editor .el-range-separator{
        width: 8%;
    }
</style>
